const NotFound = () => {
    return (
        <>
            <h1>Страница не найдена</h1>
            <h3>☹</h3>
        </>

    )
}

export default NotFound